// extracted by mini-css-extract-plugin
export default {"textArea":"CustomTextArea_textArea__19JpX","messageTextArea":"CustomTextArea_messageTextArea__TWvRs"};